'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hu_HU = require('../../date-picker/locale/hu_HU');

var _hu_HU2 = _interopRequireDefault(_hu_HU);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _hu_HU2['default'];